import { describeBatteryPricingError } from "~/api/battery-pricing-errors"
import useBatteryProposal from "~/api/hooks/useBatteryProposal"
import useCalculateBatteryProposalPricing from "~/api/hooks/useCalculateBatteryProposalPricing"

import { isBatteryProposalReadOnly } from "./battery-proposal-read-only"
import {
  describePricingError,
  RefreshPricingAction as SharedRefreshPricingAction,
} from "../ProposalPresentation/pricing/refresh-pricing-action"

/**
 * Battery's Refresh Pricing, for its drawers and the Concert Reserve now
 * action: the shared action wired to Battery's proposal read and pricing
 * command.
 */
export function RefreshPricingAction({
  proposalId,
  label,
  onRefreshed,
}: {
  proposalId: string
  label?: string
  onRefreshed?: () => void
}): JSX.Element {
  // Every caller renders inside the Battery proposal shell, which has already
  // loaded this proposal, so this reads the cached read contract rather than
  // re-deriving the update rule from a permission list.
  const { data: proposal } = useBatteryProposal(proposalId)
  const canEdit = proposal != null && !isBatteryProposalReadOnly(proposal)
  const refreshPricing = useCalculateBatteryProposalPricing()

  return (
    <SharedRefreshPricingAction
      mutation={refreshPricing}
      variables={{ proposalId }}
      canEdit={canEdit}
      describeError={(error) =>
        describeBatteryPricingError(error, describePricingError(error))
      }
      label={label}
      onRefreshed={onRefreshed}
    />
  )
}
